import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type DebugLogEntry = {
  id: string;
  ts: number;
  area: 'ai' | 'settings' | 'auth' | 'other';
  event: string;
  data?: Record<string, unknown>;
};

type DebugLogState = {
  entries: DebugLogEntry[];
  add: (entry: Omit<DebugLogEntry, 'id' | 'ts'> & { ts?: number; id?: string }) => void;
  clear: () => void;
};

const MAX_ENTRIES = 200;

export const useDebugLogStore = create<DebugLogState>()(
  persist(
    (set, get) => ({
      entries: [],
      add: (entry) => {
        const e: DebugLogEntry = {
          id: entry.id ?? crypto.randomUUID(),
          ts: entry.ts ?? Date.now(),
          area: entry.area,
          event: entry.event,
          data: entry.data,
        };
        const next = [...get().entries, e].slice(-MAX_ENTRIES);
        set({ entries: next });
      },
      clear: () => set({ entries: [] }),
    }),
    {
      name: 'ui-grace-debug-log',
      partialize: (s) => ({ entries: s.entries }),
    }
  )
);

